import {createSelector} from '@reduxjs/toolkit';
import isEqual from 'lodash.isequal';
import {createPredicates} from 'src/modules/change-requests/filter-utils/createPredicates';
import {getChangeRequestsFilters} from 'src/modules/change-requests/services/filters';
import {defaultState} from 'src/modules/change-requests/services/filters/reducer';
import {getChangeRequestsCount} from 'src/modules/tabs-panel/services/selectors';
import {ChangeRequest} from 'src/openapi/models/ChangeRequest';
import {RootState} from 'src/store/store';
import {filterDataByPredicates} from 'src/utils/filterDataByPredicates';

export const getChangeRequests = (state: RootState): Array<ChangeRequest> => state.changeRequests.data;

export const getFilteredChangeRequests = createSelector(
    [getChangeRequestsFilters, getChangeRequests],
    (filters, rows = []) => filterDataByPredicates(rows, filters, createPredicates),
);

export const getFilteredChangeRequestsLength = createSelector(
    [getFilteredChangeRequests, getChangeRequestsCount, getChangeRequestsFilters],
    (filteredChangeRequests, changeRequestsCount, filters) => {
        const isDefaultFilters = isEqual(filters, defaultState.data);

        return isDefaultFilters ? changeRequestsCount : filteredChangeRequests.length;
    },
);
